import { Link } from "react-router-dom";
import { pillars } from "@/data/pillars";
export default function ServicesOverview() {
  return (
    <section className="section-space">
      <div className="shell">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Our work</p>
            <h2>Three ways to move forward.</h2>
          </div>
          <Link className="text-link" to="/services">
            Explore all areas <span aria-hidden="true">↗</span>
          </Link>
        </div>
        <div className="pillar-grid">
          {pillars.map((p) => (
            <Link to={p.link} key={p.id} className="pillar-card">
              <span className="pillar-number">{p.number}</span>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
              <span className="text-link">
                {p.action} <span aria-hidden="true">↗</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
